import React, { FunctionComponent } from 'react'

import styled, { useTheme } from 'styled-components/native'

import { PressableOpacity } from '../../atoms/pressableOpacity/PressableOpacity'
import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { BodyText } from '../bodyText/BodyText'
import { PlusIcon } from '../icons/PlusIcon'

export interface TemplateDynamicTextProps {
  name: React.ReactNode
  onPress?: () => void
  withIcon?: boolean
}

const Container = styled(PressableOpacity)<{
  theme: ThemeType
}>(({ theme }: { theme: ThemeType }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.backgroundSection,
  borderRadius: theme.spacing['4px'],
  display: 'inline-flex',
  flexDirection: 'row',
  paddingLeft: theme.spacing['4px'],
  paddingRight: theme.spacing['4px'],
  gap: '2px',
}))

export const TemplateDynamicText: FunctionComponent<TemplateDynamicTextProps> = ({
  name,
  onPress,
  withIcon = true,
}) => {
  const theme = useTheme()
  return (
    <Container theme={theme} testID={tID(`TemplateDynamicText-${name as string}`)} onPress={onPress}>
      {withIcon && <PlusIcon width={12} fillColor={theme.colors.iconDefault} />}
      <BodyText size={BodyTextSize.BADGE}>{name}</BodyText>
    </Container>
  )
}
